<template>
  <form class="has-sticky-submit" @submit.prevent="submit">
    <div class="card">
      <div class="card-header">
        <div class="card-header-title">
          {{ titleDescription }}
        </div>
        <div class="card-header-icon">
          <div class="field has-addons is-marginless">
            <div class="control">
              <router-link
                :to="{ name: 'marketing.periodicDiscounts.list' }"
                class="button"
              >
                <span class="icon is-small"><i class="fa fa-list-ul"/></span
                ><span>Λίστα</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-half">
            <div class="field">
              <label class="label">Τίτλος *</label>
              <div class="control">
                <input
                  v-validate="'required'"
                  v-model.trim="form.title"
                  class="input"
                  type="text"
                  name="title"
                />
                <p v-show="errors.has('title')" class="help is-danger">
                  Εισάγετε τίτλο
                </p>
              </div>
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label">Ποσοστό Έκπτωσης *</label>
              <div class="control">
                <input
                  v-validate="'required|min_value:0'"
                  v-model.trim.number="form.discount"
                  class="input"
                  type="number"
                  min="0"
                  step="0.01"
                  name="discount"
                />
                <p v-show="errors.has('discount')" class="help is-danger">
                  Εισάγετε ποσοστό έκπτωσης
                </p>
              </div>
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label">Ενεργό *</label>
              <div class="control">
                <div class="select select is-fullwidth">
                  <select v-model.number="form.active" name="active">
                    <option :value="false">Όχι</option>
                    <option :value="true">Ναί</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label">Sold Limit *</label>
              <div class="control">
                <input
                  v-validate="'required|excluded:0'"
                  v-model.trim.number="form.sold_limit"
                  class="input"
                  type="number"
                  name="sold_limit"
                  min="0"
                  step="1"
                />
                <p v-show="errors.has('sold_limit')" class="help is-danger">
                  Εισάγετε Τεμάχια
                </p>
              </div>
            </div>
          </div>

          <div class="column">
            <label class="label">
              Ημερομηνία Εκκίνησης *
            </label>
            <div class="field has-addons">
              <div class="control is-expanded">
                <DatePicker
                  id="date"
                  v-model="form.date_start"
                  name="date_start"
                  type="date"
                  value-type="format"
                  format="YYYY-MM-DD"
                />
                <p v-show="errors.has('date_start')" class="help is-danger">
                  Εισάγετε ημ/νία εκκίνησης
                </p>
              </div>
            </div>
          </div>

          <div class="column">
            <label class="label">
              Ημερομηνία Λήξης *
            </label>
            <div class="field has-addons">
              <div class="control is-expanded">
                <DatePicker
                  id="date"
                  v-model="form.date_end"
                  name="date_end"
                  type="date"
                  value-type="format"
                  format="YYYY-MM-DD"
                />
                <p v-show="errors.has('date_end')" class="help is-danger">
                  Εισάγετε ημ/νία λήξης
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ToggleableCard :is-open="true" title="Σχετικά Προϊόντα">
      <div class="card-content">
        <div class="field">
          <label class="label">Προϊόντα</label>
          <div class="control">
            <ProductsSearch
              :products="form.products"
              @selectProduct="selectProduct"
              @removeProduct="removeProduct"
            />
          </div>
        </div>
      </div>
    </ToggleableCard>

    <StickyFormFooter>
      <template v-slot:left>
        <FormSubmit :is-saving="isSaving" @reset="reset" />
      </template>
    </StickyFormFooter>
  </form>
</template>

<script>
import moment from 'moment';
import { pick } from 'lodash';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import AddItem from '@/views/components/AddItem';
import request from '@/utils/request';
import ProductsSearch from '@/views/components/ProductsSearch';
import StickyFormFooter from '@/views/components/StickyFormFooter';
import ToggleableCard from '@/views/components/ToggleableCard';

export default {
  components: {
    ToggleableCard,
    ProductsSearch,
    StickyFormFooter,
    DatePicker,
  },

  extends: AddItem,

  data() {
    return {
      periodic_discount: {},
      form: {},
      isLoadingPhotos: false,
      disabledDates: new Date(),
    };
  },

  computed: {
    titleDescription() {
      // eslint-disable-next-line camelcase
      const { periodic_discount } = this;
      /* eslint-disable */ if (periodic_discount.active === true) {
        return 'Ενεργή Περιοδική Έκπτωση';
      } else if (periodic_discount.active === false) {
        return 'Μη Ενεργή Περιοδική Έκπτωση';
      } else {
        return 'Περιοδική Έκπτωση';
      }
    },
  },

  async created() {
    try {
      const { data } = await request.get(
        `/periodic-discounts/${this.$route.params.uuid}`,
      );

      this.periodic_discount = { ...data.periodicDiscount };
      this.form = { ...data.periodicDiscount };
    } catch (err) {
      console.log(err);
    }
  },

  methods: {
    utcToLocalDate(date) {
      //parse the date strings as UTC Time
      const utcDate = new Date(Date.parse(date + 'Z'));

      // conver date string to local date objects
      return this.formatDate(utcDate);
    },

    formatDate(date) {
      return moment(date).format('DD-MM-YYYY-HH:mm');
    },

    disableDate(date) {
      if (
        moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD') <
        moment()
          .add(2, 'days')
          .format('YYYY-MM-DD')
      ) {
        return true;
      }
      return false;
    },

    setData(data) {
      this.periodic_discount = {
        ...data.periodicDiscount,
      };

      this.form = pick(this.periodic_discount, [
        'title',
        'active',
        'sold_limit',
        'discount',
        'date_start',
        'date_end',
        'products',
      ]);
    },

    async submit() {
      try {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          throw Error('Client-side validation failed');
        }

        this.isSaving = true;

        const response1 = await request.put(
          `/periodic-discounts/${this.periodic_discount.id}`,
          {
            ...this.form,
            products: this.form.products.map(({ id }) => id),
          },
        );

        if (response1.data.error) {
          throw Error('Server-side validation failed');
        }

        const response2 = await request.get(
          `/periodic-discounts/${this.$route.params.uuid}`,
        );

        this.periodic_discount = { ...response2.data.periodicDiscount };
        this.form = { ...response2.data.periodicDiscount };
        this.isSaving = false;

        this.$notify({
          type: 'success',
          title: 'Επιτυχία',
          text: 'Η Περιοδική Έκπτωση αποθηκεύτηκε',
        });
      } catch (err) {
        this.isSaving = false;
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      }
    },

    selectProduct(product) {
      this.form = {
        ...this.form,
        products: [...(this.form.products || []), product],
      };
    },

    removeProduct(product) {
      this.form = {
        ...this.form,
        products: this.form.products.filter(({ id }) => id !== product.id),
      };
    },

    reset() {
      this.form = pick(this.periodic_discount, [
        'title',
        'active',
        'sold_limit',
        'discount',
        'date_start',
        'date_end',
        'products',
      ]);

      this.$validator.reset();
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .mx-datepicker {
  width: 100% !important;
}

::v-deep .mx-datepicker-main {
  border-radius: 12px;

  .mx-datepicker-body {
    border-radius: 12px;
  }

  .mx-calendar {
    border-radius: 12px;
    width: 100% !important;

    .mx-calendar-content .cell.active {
      background-color: #16c995 !important;
      text-align: center;
      border-radius: 12px;
    }
    .mx-calendar-content .cell {
      text-align: center;
      border-radius: 12px;
    }

    & .cell.disabled {
      background-color: #111 !important;
    }
  }
}
</style>
